import { BACKENDS, DOMAIN } from 'config';
import { useContext } from 'react';
import { useLocation } from 'react-router';
import { RootContext } from '@stores';

export function useIFrameUrl(): string {
  const { local } = useContext(RootContext);

  // TODO: 正式环境不需要加 token？
  const { pathname, search } = useLocation();
  const params = local.token != null ? `access_token=${local.token}` : '';
  let url = '';

  if (pathname.startsWith('/training')) {
    const path = pathname.replace(/^\/(training)\//, '');
    const urlParams = search.replace('?', '&');
    const domains = Object.entries(DOMAIN)
      .filter(([, value]) => value === 'training')
      .map(([key]) => key);
    const BACKEND = domains.includes(location.hostname) ? location.origin : BACKENDS.TRAINING;
    url = `${BACKEND}/${path}?${params}${urlParams}`;
  }

  if (pathname.startsWith('/shoteyes')) {
    const domains = Object.entries(DOMAIN)
      .filter(([, value]) => value === 'shoteyes')
      .map(([key]) => key);
    const BACKEND = domains.includes(location.hostname) ? location.origin : BACKENDS.SHOTEYES;
    const path = pathname.replace(/^\/(shoteyes)\//, '');
    if (search != null && search !== '') {
      // 如果有 search，说明是从其他页面跳转过来的
      url = `${BACKEND}/${path}${search}&${params}`;
    } else {
      url = `${BACKEND}/${path}?${params}`;
    }
  }

  if (pathname.startsWith('/detective')) {
    const path = pathname.replace(/^\/(detective)\//, '');
    url = `${BACKENDS.DETECTIVE}/${path}?${params}`;
  }

  return url;
}
